import React from 'react';
import LeadStagePanel from '../../templates/LeadStagePanel';

export default function LeadNodeEditor({ templateType, settings, onSettingsChange }) {
  return (
    <LeadStagePanel
      templateType={templateType}
      settings={settings}
      onSettingsChange={onSettingsChange}
      compact
    />
  );
}
